(() => {
  if (window.__FL_GATE_LOADED__) return;
  window.__FL_GATE_LOADED__ = true;

  const GEO_ENDPOINT = "https://ipapi.co/json/";
  const CACHE_KEY = "visitor_state_code_v2";
  const CACHE_MINUTES = 60;

  // If geo fails: true = treat as FL (normal ATC); false = treat as non-FL (redirect)
  const DEFAULT_IS_FL = true;

  // Cache product .js fetch per pathname
  const __productJsCache = new Map();

  function ensureGateCSS() {
    if (document.getElementById("fl-gate-css")) return;

    const style = document.createElement("style");
    style.id = "fl-gate-css";
    style.textContent = `
      html[data-fl-gate="fl"] [data-atc-outsidefl="true"] { display: none !important; }
      html[data-fl-gate="fl"] [data-atc-fl="true"] { display: inline-flex !important; justify-content: center; }

      html[data-fl-gate="nonfl"] [data-atc-fl="true"] { display: none !important; }
      html[data-fl-gate="nonfl"] [data-atc-outsidefl="true"] { display: inline-flex !important; justify-content: center; }
    `;
    document.head.appendChild(style);
  }

  function setGate(isFL) {
    document.documentElement.setAttribute("data-fl-gate", isFL ? "fl" : "nonfl");
  }

  function getCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const obj = JSON.parse(raw);
      if (!obj?.state || !obj?.ts) return null;
      const ageMin = (Date.now() - obj.ts) / (1000 * 60);
      if (ageMin > CACHE_MINUTES) return null;
      return String(obj.state).trim().toUpperCase();
    } catch {
      return null;
    }
  }

  function setCache(state) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ state, ts: Date.now() }));
    } catch {}
  }

  async function detectState() {
    const cached = getCache();
    if (cached) return cached;

    const res = await fetch(GEO_ENDPOINT, { cache: "no-store" });
    if (!res.ok) throw new Error("geo failed");
    const data = await res.json();

    const state = String(data.region_code || "").trim().toUpperCase();
    if (state) setCache(state);
    return state || null;
  }

  // -------------------------
  // QTY (theme-agnostic + Focal-safe)
  // -------------------------
  function getQty(fromEl) {
    const formEl = fromEl.closest("form");
    const formId = formEl?.id;

    // 1) quantity input linked via form="..."
    if (formId) {
      const linked =
        document.querySelector(`input[name="quantity"][form="${CSS.escape(formId)}"]`) ||
        document.querySelector(`input[type="number"][form="${CSS.escape(formId)}"]`);
      const n = parseInt(linked?.value, 10);
      if (Number.isFinite(n) && n > 0) return n;
    }

    // 2) quantity input inside the form
    if (formEl) {
      const inside =
        formEl.querySelector('input[name="quantity"]') ||
        formEl.querySelector('input[type="number"]');
      const n = parseInt(inside?.value, 10);
      if (Number.isFinite(n) && n > 0) return n;
    }

    // 3) last resort
    const any =
      document.querySelector('input[name="quantity"]') ||
      document.querySelector('input[type="number"]');
    const n = parseInt(any?.value, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  // -------------------------
  // VARIANT + SKU (theme-agnostic)
  // -------------------------
  function getVariantId(fromEl) {
    // 1) URL param
    const urlVariant = new URLSearchParams(window.location.search).get("variant");
    if (urlVariant && /^\d+$/.test(urlVariant)) return String(urlVariant);

    // 2) any id field (even if disabled)
    const formEl = fromEl.closest("form");
    const formId = formEl?.id;

    if (formId) {
      const linkedId =
        document.querySelector(`input[name="id"][form="${CSS.escape(formId)}"]`) ||
        document.querySelector(`select[name="id"][form="${CSS.escape(formId)}"]`);
      if (linkedId?.value && /^\d+$/.test(String(linkedId.value))) return String(linkedId.value);
    }

    if (formEl) {
      const inFormId =
        formEl.querySelector('input[name="id"]') ||
        formEl.querySelector('select[name="id"]');
      if (inFormId?.value && /^\d+$/.test(String(inFormId.value))) return String(inFormId.value);
    }

    const any =
      document.querySelector('input[name="id"]') ||
      document.querySelector('select[name="id"]');
    if (any?.value && /^\d+$/.test(String(any.value))) return String(any.value);

    return null;
  }

  async function fetchProductJs() {
    const key = window.location.pathname;
    if (__productJsCache.has(key)) return __productJsCache.get(key);

    const p = (async () => {
      const url = `${window.location.origin}${window.location.pathname}.js`;
      const res = await fetch(url, { cache: "no-store" });
      if (!res.ok) throw new Error("product.js fetch failed");
      return res.json();
    })();

    __productJsCache.set(key, p);
    return p;
  }

  async function getVariantSKU(fromEl) {
    const variantId = getVariantId(fromEl);
    if (!variantId) return null;

    try {
      const product = await fetchProductJs();
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      const match = variants.find((v) => String(v?.id) === String(variantId));
      const sku = match?.sku ? String(match.sku) : null;
      return sku || null;
    } catch {
      return null;
    }
  }

  // -------------------------
  // Outside-FL redirect wiring
  // -------------------------
  function wireOutsideButtons() {
    document
      .querySelectorAll('[data-atc-outsidefl="true"][data-outsidefl-url]')
      .forEach((btn) => {
        if (btn.__wired) return;
        btn.__wired = true;

        btn.addEventListener("click", async (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const template = btn.getAttribute("data-outsidefl-url");
          if (!template) return;

          const qty = getQty(btn);
          const sku = await getVariantSKU(btn);

          if (!sku) {
            console.warn("[fl-gate] Could not resolve SKU for current variant.");
            return;
          }

          const url = template
            .replace("__SKU__", encodeURIComponent(sku))
            .replace("__QTY__", encodeURIComponent(String(qty)));

          window.location.href = url;
        });
      });
  }

  // Optional: keep outside button disabled state in sync with real ATC button
  function syncDisabledState() {
    document.querySelectorAll('[data-atc-outsidefl="true"]').forEach((outBtn) => {
      const form = outBtn.closest("form");
      if (!form) return;

      const flBtn = form.querySelector('[data-atc-fl="true"]');
      if (!flBtn) return;

      const shouldBeDisabled = !!flBtn.disabled;
      if (outBtn.disabled !== shouldBeDisabled) outBtn.disabled = shouldBeDisabled;
    });
  }

  async function init() {
    ensureGateCSS();

    // avoid flicker
    setGate(DEFAULT_IS_FL);
    wireOutsideButtons();
    syncDisabledState();

    let state = null;
    try {
      state = await detectState();
    } catch {
      state = null;
    }

    const isFL = state === "FL" || state === null ? DEFAULT_IS_FL : false;
    setGate(isFL);

    wireOutsideButtons();
    syncDisabledState();
  }

  init();

  const obs = new MutationObserver(() => {
    wireOutsideButtons();
    syncDisabledState();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();